module.exports = __webpack_public_path__ + "static/img/freight-car_256.45df8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freight-car_256.png
// module id = AMZq
// module chunks = 0